module.exports = __webpack_public_path__ + "img/cx.010e6411.png";